// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";
// import {
//   fetchWalletBalance,
//   fetchLienBalance,
// } from "../../../Store/Slices/WalletSlice";
// import DynamicTable from "../../../ResuableCompoment/DynamicTable";
// import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
// import * as XLSX from "xlsx";

// /* ===== HELPER ===== */
// const getToday = () => {
//   const d = new Date();
//   return d.toISOString().split("T")[0];
// };

// const CommissionRetailer = () => {
//   const dispatch = useDispatch();
//   const { username, merchant_account_no, userId } =
//     useSelector((s) => s.auth.employeeDetails) || {};

//   const [activeTab, setActiveTab] = useState("COMMISSION");

//   /* ================= COMMISSION BALANCE ================= */
//   const [commissionBalance, setCommissionBalance] = useState(0);

//   const { callApi: commissionApi } = useApi(
//     `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
//     "GET"
//   );

//   const { callApi: transferCommissionToMain } = useApi(
//     "/business/wallet/settle",
//     "POST"
//   );

//   const { callApi: Commissionledgerreport } = useApi(
//     "/ledger/commission",
//     "GET"
//   );

//   /* ================= TABLE STATES ================= */
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [page, setPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const pageSize = 10;

//   /* ================= TRANSFER STATES ================= */
//   const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
//   const [isLoadingCommission, setIsLoadingCommission] = useState(false);
//   const [commissionMessage, setCommissionMessage] = useState("");

//   const [fromDate, setFromDate] = useState(getToday());
//   const [toDate, setToDate] = useState(getToday());

//   /* ================= LOAD BALANCE ================= */
//   useEffect(() => {
//     loadCommissionBalance();
//     fetchCommissionLedger();
//   }, []);

//   const loadCommissionBalance = async () => {
//     const res = await commissionApi();
//     setCommissionBalance(res?.balance || 0);
//   };

//   /* ================= FETCH LEDGER ================= */
//   const fetchCommissionLedger = async (targetPage = 0, loadMore = false) => {
//     setLoading(true);
//     try {
//       const query = `?bid=${username}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}`;

//       const res = await Commissionledgerreport(null, query);
//       const data = (res?.content || []).filter(Boolean);

//       setTotalPages(res?.totalPages || 0);

//       setHistory((prev) =>
//         loadMore ? [...prev, ...data] : data
//       );

//       setPage(targetPage);
//     } catch (err) {
//       console.error(err);
//       if (!loadMore) setHistory([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= LOAD MORE ================= */
//   const handleLoadMore = () => {
//     if (page + 1 < totalPages) {
//       fetchCommissionLedger(page + 1, true);
//     }
//   };

//   /* ================= TRANSFER ================= */
//   const handleCommissionToMainTransfer = async () => {
//     if (!transferCommissionAmount || transferCommissionAmount <= 0) {
//       setCommissionMessage("Please enter a valid amount.");
//       return;
//     }

//     setIsLoadingCommission(true);
//     setCommissionMessage("");

//     try {
//       const res = await transferCommissionToMain(
//         null,
//         `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
//       );

//       if (res.status === "SUCCESS") {
//         setCommissionMessage(
//           "Commission transferred successfully."
//         );

//         dispatch(fetchWalletBalance());
//         dispatch(fetchLienBalance());

//         await loadCommissionBalance();
//       } else {
//         setCommissionMessage(res.message || "Transfer failed.");
//       }
//     } catch (err) {
//       setCommissionMessage("Error transferring commission.");
//     } finally {
//       setIsLoadingCommission(false);
//       setTransferCommissionAmount("");

//       setTimeout(() => setCommissionMessage(""), 2000);
//     }
//   };

//   /* ================= TOTALS ================= */

//   const totalNetAmount = history.reduce(
//     (sum, tx) => sum + Number(tx?.netAmount || 0),
//     0
//   );


//   const totalTds = history.reduce(
//     (sum, tx) => sum + Number(tx?.tds || 0),
//     0
//   );

//   const totalCommission = history.reduce(
//     (sum, tx) => sum + Number(tx?.commission || 0),
//     0
//   );

//   const columns = [
//     { key: "txnId", label: "Txn ID" },
//     {
//       key: "txnDate",
//       label: "Date",
//       render: (v) => getDisplayDate(v),
//     },
//     {
//       key: "narration",
//       label: "Narration",
//       render: (v) => (
//         <span className="text-indigo-700 font-medium">
//           {v || "—"}
//         </span>
//       ),
//     },


//     {
//       key: "commission",
//       label: "Comm",
//       render: (v) => (
//         <span className="font-bold text-green-800">
//           ₹{Number(v || 0)?.toFixed(2)}
//         </span>
//       ),
//     },


//     {
//       key: "tds",
//       label: "TDS",
//       render: (v) => (
//         <span className="font-semibold text-red-800">
//           ₹{Number(v || 0)?.toFixed(2)}
//         </span>
//       ),
//     },

//     {
//       key: "txnAmount",
//       label: "Net Amount",
//       render: (v, row) => {
//         const value = Number(v || 0);
//         if (!value) return <span className="text-gray-400">—</span>;

//         if (row.txnType === "CREDIT" || row.txnType === "Approved" || row.txnType === "REFUND")
//           return (
//             <span className="font-semibold text-green-700">
//               ₹{value?.toFixed(2)}
//             </span>
//           );

//         if (row.txnType === "DEBIT")
//           return (
//             <span className="font-semibold text-red-600">
//               ₹{value?.toFixed(2)}
//             </span>
//           );
//         return <span className="text-gray-400">—</span>;
//       },
//     },

//     {
//       key: "balance",
//       label: "Balance",
//       render: (v) => (
//         <span className="font-semibold text-blue-900">
//           ₹{Number(v || 0)?.toFixed(2)}
//         </span>
//       ),
//     },
//   ];


  
//   //       const downloadExcel = () => {
//   //   const rows = history.map((r) => ({
//   //     TxnID: r.txnId,
//   //     Date: r.txnDate,
//   //     Aadhaar: r.narration,
//   //     TxnAmount: r.txnAmount,
//   //     NetAmount: r.netAmount,
//   //     Charges: r.charges,
//   //     Cashback: r.cashback,
//   //     Commission: r.commission,
//   //     TDS: r.tds,
//   //     Balance: r.balance,
//   //     Mobile: r.shopname,
//   //     Status: r.txnType,
//   //   }));
  
//   //   const ws = XLSX.utils.json_to_sheet(rows);
//   //   const wb = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(wb, ws, "Commission legder Report");
//   //   XLSX.writeFile(wb, "Commision_ledger_Report.xlsx");
//   // };

// const [downloadLoader,setDownloadLoader]= useState(false)
// //   const downloadExcel = async () => {
// //   if (!username) return;
// //   setDownloadLoader(true);

// //   let allData = [];
// //   let currentPage = 0;
// //   let totalPagesLocal = 1;
// //   const size = pageSize; 

// //   try {
// //     while (currentPage < totalPagesLocal) {
// //       let query = `?bid=${username}&page=${currentPage}&size=${size}`;

// //       if (fromDate) query += `&fromDate=${fromDate}`;
// //       if (toDate) query += `&toDate=${toDate}`;

// //       const res = await Commissionledgerreport(null, query);

// //       const data = res?.content || [];
// //       allData = [...allData, ...data];

// //       totalPagesLocal = res?.totalPages || 1;
// //       currentPage++;
// //     }

// //     if (!allData.length) {
// //       alert("No commission ledger found for this date range");
// //       return;
// //     }

// //     const formattedRows = allData.map((r) => ({
// //       "Txn ID": r.txnId,
// //       Date: new Date(r.txnDate).toLocaleString("en-IN"),
// //       Narration: r.narration,
// //       "Txn Amount": r.txnAmount,
// //       "Net Amount": r.netAmount,
// //       Charges: r.charges,
// //       Cashback: r.cashback,
// //       Commission: r.commission,
// //       TDS: r.tds,
// //       Balance: r.balance,
// //       Mobile: r.shopname,
// //       Status: r.txnType,
// //     }));

// //     const ws = XLSX.utils.json_to_sheet(formattedRows);
// //     const wb = XLSX.utils.book_new();

// //     XLSX.utils.book_append_sheet(wb, ws, "Commission Ledger");

// //     XLSX.writeFile(
// //       wb,
// //       `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`
// //     );

// //   } catch (err) {
// //     console.error(err);
// //     alert("Commission Excel download failed");
// //   }
// //   finally{
// //     setDownloadLoader(false)
// //   }
// // };

// const downloadExcel = async () => {
//   if (!username) return;

//   setDownloadLoader(true);

//   let allData = [];
//   let currentPage = 0;
//   const size = pageSize;

//   try {
//     while (true) {
//       let query = `?bid=${username}&page=${currentPage}&size=${size}`;

//       if (fromDate) query += `&fromDate=${fromDate}`;
//       if (toDate) query += `&toDate=${toDate}`;

//       console.log("Fetching page:", currentPage);

//       const res = await Commissionledgerreport(null, query);

//       const data = res?.content || [];

//       // ✅ STOP CONDITION 1: No data returned
//       if (!data.length) {
//         console.log("No more data → stopping");
//         break;
//       }

//       allData = [...allData, ...data];

//       // ✅ STOP CONDITION 2: last page reached
//       const totalPages = res?.totalPages;

//       if (typeof totalPages === "number" && currentPage >= totalPages - 1) {
//         console.log("Last page reached → stopping");
//         break;
//       }

//       // ✅ STOP CONDITION 3 (VERY IMPORTANT):
//       // If API keeps returning same data → break
//       if (data.length < size) {
//         console.log("Last partial page → stopping");
//         break;
//       }

//       currentPage++;
//     }

//     if (!allData.length) {
//       alert("No commission ledger found for this date range");
//       return;
//     }

//     const formattedRows = allData.map((r) => ({
//       "Txn ID": r.txnId,
//       Date: new Date(r.txnDate).toLocaleString("en-IN"),
//       Narration: r.narration,
//       "Txn Amount": r.txnAmount,
//       "Net Amount": r.netAmount,
//       Charges: r.charges,
//       Cashback: r.cashback,
//       Commission: r.commission,
//       TDS: r.tds,
//       Balance: r.balance,
//       Mobile: r.shopname,
//       Status: r.txnType,
//     }));

//     const ws = XLSX.utils.json_to_sheet(formattedRows);
//     const wb = XLSX.utils.book_new();

//     XLSX.utils.book_append_sheet(wb, ws, "Commission Ledger");

//     XLSX.writeFile(
//       wb,
//       `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`
//     );

//   } catch (err) {
//     console.error(err);
//     alert("Commission Excel download failed");
//   } finally {
//     setDownloadLoader(false);
//   }
// };

//   /* ================= UI ================= */
//   return (
//     <div className="min-h-screen sm:p-6">

//       {/* HEADER */}
//       {/* <h1 className="text-2xl font-bold mb-6">Commission Section</h1> */}

//       <div className="mb-8">
//         <h1 className="text-3xl font-bold text-[#0A2A4F]">
//           Commission Section
//         </h1>
//         <p className="text-gray-600 text-sm mt-1">
//           Manage commission reports and transfers
//         </p>
//       </div>

      
//       {/* TABS */}
//       <div className="flex mb-6 rounded-xl overflow-hidden shadow">
//         <button
//           onClick={() => setActiveTab("COMMISSION")}
//           className={`flex-1 py-3 ${activeTab === "COMMISSION"
//             ? "bg-[#0A2A4F] text-white"
//             : "bg-white"
//             }`}
//         >
//           Report
//         </button>

//         <button
//           onClick={() => setActiveTab("TRANSFER")}
//           className={`flex-1 py-3 ${activeTab === "TRANSFER"
//             ? "bg-amber-600 text-white"
//             : "bg-white"
//             }`}
//         >
//           Transfer
//         </button>
//       </div>

//       <div>

//         {activeTab === "COMMISSION" && (
//           <>
//             {/* FILTER */}
//             {/* <div className="flex gap-3 mb-4">
//               <input
//                 type="date"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//                 className="border px-2 py-1 rounded"
//               />

//               <input
//                 type="date"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//                 className="border px-2 py-1 rounded"
//               />

//               <button
//                 onClick={() => fetchCommissionLedger(0)}
//                 className="bg-blue-900 text-white px-4 rounded"
//               >
//                 Search
//               </button>
//             </div> */}



//       <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
//         <div className="flex flex-wrap items-center gap-4">

          

//           {/* 📅 From Date */}
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//           {/* 📅 To Date */}
//           <input
//             type="date"
//             value={toDate}
//             min={fromDate}
//             onChange={(e) => setToDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//            <button
//                 onClick={() => fetchCommissionLedger(0)}
//                 className="bg-[#0A2A4F] text-white px-6 py-2 rounded-lg"
//               >
//                 Search
//               </button>


//           {/* 📥 Download */}
//           {/* <button
//             onClick={downloadExcel}
//             className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
//                  shadow hover:bg-green-700 transition"
//           >
//             Download Excel
//           </button> */}
//           <button
//   onClick={downloadExcel}
//   disabled={downloadLoader}
//   className={`h-10 px-6 rounded-lg text-white font-semibold shadow transition
//     ${loading ? "bg-green-300 cursor-not-allowed" : "bg-green-600 hover:bg-green-400"}`}
// >
//   {downloadLoader ? (
//     <div className="flex items-center gap-2">
//       <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//       Preparing Excel...
//     </div>
//   ) : (
//     "Download Excel"
//   )}
// </button>

//         </div>
//       </div>




//             {/* TABLE */}
//             <DynamicTable
//               columns={columns}
//               data={history}
//               isLoading={loading}
//               rowClassName={(row) => {
//                 if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
//                   return "bg-red-100"; // 🔴 Darker Debit
//                 }

//                 if (row.txnType === "REFUND") {
//                   return "bg-yellow-100"; // 🟡 Darker Refund
//                 }

//                 if (
//                   row.txnType === "CREDIT" ||
//                   row.txnType === "APPROVED"
//                 ) {
//                   return "bg-green-100"; // 🟢 Darker Credit
//                 }

//                 if (row.txnType === "REJECTED") {
//                   return "bg-red-200 border-l-4 border-red-600"; // 🔴 More strong rejected
//                 }

//                 return "";
//               }}
//               footerTotals={{
//                 totalNetAmount,
//                 totalTds,
//                 totalCommission,
//               }}
//             />

//             {/* LOAD MORE */}
//             {page + 1 < totalPages && (
//               <div className="text-center mt-4">
//                 <button
//                   onClick={handleLoadMore}
//                   className="px-5 py-2 bg-[#0A2A4F] text-white rounded"
//                 >
//                   {loading ? "Loading..." : "Load More"}
//                 </button>
//               </div>
//             )}
//           </>
//         )}

//         {activeTab === "TRANSFER" && (
//           <div className="max-w-md">
//             <p className="mb-2 font-semibold">
//               Balance: ₹{commissionBalance}
//             </p>

//             <input
//               type="number"
//               value={transferCommissionAmount}
//               onChange={(e) =>
//                 setTransferCommissionAmount(e.target.value)
//               }
//               className="w-full border p-2 mb-3 rounded"
//               placeholder="Enter amount"
//             />

//             <button
//               onClick={handleCommissionToMainTransfer}
//               className="w-full bg-amber-600 text-white py-2 rounded"
//             >
//               {isLoadingCommission ? "Processing..." : "Transfer"}
//             </button>

//             {commissionMessage && (
//               <p className="mt-2 text-blue-600">
//                 {commissionMessage}
//               </p>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CommissionRetailer;




import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import {
  fetchWalletBalance,
  fetchLienBalance,
} from "../../../Store/Slices/WalletSlice";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import * as XLSX from "xlsx";

/* ===== HELPER ===== */
const getToday = () => {
  const d = new Date();
  return d.toISOString().split("T")[0];
};

const CommissionRetailer = () => {
  const dispatch = useDispatch();
  const { username, merchant_account_no, userId } =
    useSelector((s) => s.auth.employeeDetails) || {};

  /* ================= ALL STATES ================= */
  const [activeTab, setActiveTab] = useState("COMMISSION");
  const [commissionBalance, setCommissionBalance] = useState(0);

  // Table & Pagination States
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const pageSize = 10;

  

  // Filter & Export States
  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());
  const [isExporting, setIsExporting] = useState(false);
  const [isSearched, setIsSearched] = useState(false);

  // Transfer States
  const [transferCommissionAmount, setTransferCommissionAmount] = useState("");
  const [isLoadingCommission, setIsLoadingCommission] = useState(false);
  const [commissionMessage, setCommissionMessage] = useState("");

  /* ================= APIS ================= */
  const { callApi: commissionApi } = useApi(
    `/business/wallet/view/settle/balance?mid=${username}&account_no=${merchant_account_no}`,
    "GET"
  );

  const { callApi: transferCommissionToMain } = useApi(
    "/business/wallet/settle",
    "POST"
  );

  const { callApi: Commissionledgerreport } = useApi(
    "/ledger/commission",
    "GET"
  );

  /* ================= EFFECTS ================= */
  // Load initial data
  useEffect(() => {
    loadCommissionBalance();
    fetchCommissionLedger(0, false);
    // eslint-disable-next-line
  }, []);

  // Reset "isSearched" if user changes dates so they must search again before exporting
  useEffect(() => {
    setIsSearched(false);
  }, [fromDate, toDate]);

  /* ================= FUNCTIONS ================= */
  const loadCommissionBalance = async () => {
    const res = await commissionApi();
    setCommissionBalance(res?.balance || 0);
  };

  const fetchCommissionLedger = async (targetPage = 0, loadMore = false) => {
    setLoading(true);
    try {
      const query = `?bid=${username}&page=${targetPage}&size=${pageSize}&fromDate=${fromDate}&toDate=${toDate}`;

      const res = await Commissionledgerreport(null, query);
      const data = (res?.content || []).filter(Boolean);

      setTotalPages(res?.totalPages || 0);
      setTotalElements(res?.totalElements || 0);

      setHistory((prev) => (loadMore ? [...prev, ...data] : data));
      setPage(targetPage);
      
      // Mark as successfully searched so export button appears
      setIsSearched(true);
    } catch (err) {
      console.error(err);
      if (!loadMore) setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (page + 1 < totalPages) {
      fetchCommissionLedger(page + 1, true);
    }
  };

  /* ================= EXCEL DOWNLOAD (DYNAMIC SIZE) ================= */
  const downloadExcel = async () => {
    setIsExporting(true);

    try {
      if (totalElements === 0) {
        alert("No data available to export.");
        setIsExporting(false);
        return;
      }

      // 1. Fetch everything at once using totalElements dynamically directly from state
      const fullQuery = `?bid=${username}&page=0&size=${totalElements}&fromDate=${fromDate}&toDate=${toDate}`;
      const fullRes = await Commissionledgerreport(null, fullQuery);
      const allData = (fullRes?.content || []).filter(Boolean);

      /* ================= FORMAT EXCEL ROWS ================= */
      const rows = allData.map((r) => ({
        "Txn ID": r.txnId || "",
        "Date": getDisplayDate(r.txnDate),
        "Narration": r.narration || "",
        "Type": r.txnType || "",
        "Net Amount": r.txnAmount || "",
        "Commission": r.commission || "",
        "TDS": r.tds || "",
        "Balance": r.balance || "",
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Commission_Ledger");

      XLSX.writeFile(wb, `Commission_Ledger_${fromDate}_to_${toDate}.xlsx`);
    } catch (err) {
      console.error("Excel download error:", err);
      alert("Excel download failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  /* ================= TRANSFER ================= */
  const handleCommissionToMainTransfer = async () => {
    if (!transferCommissionAmount || transferCommissionAmount <= 0) {
      setCommissionMessage("Please enter a valid amount.");
      return;
    }

    setIsLoadingCommission(true);
    setCommissionMessage("");

    try {
      const res = await transferCommissionToMain(
        null,
        `?amount=${parseFloat(transferCommissionAmount)}&userId=${userId}`
      );

      if (res.status === "SUCCESS") {
        setCommissionMessage("Commission transferred successfully.");
        dispatch(fetchWalletBalance());
        dispatch(fetchLienBalance());
        await loadCommissionBalance();
      } else {
        setCommissionMessage(res.message || "Transfer failed.");
      }
    } catch (err) {
      setCommissionMessage("Error transferring commission.");
    } finally {
      setIsLoadingCommission(false);
      setTransferCommissionAmount("");
      setTimeout(() => setCommissionMessage(""), 2000);
    }
  };

  /* ================= TOTALS & COLUMNS ================= */
  const totalNetAmount = history.reduce((sum, tx) => sum + Number(tx?.netAmount || 0), 0);
  const totalTds = history.reduce((sum, tx) => sum + Number(tx?.tds || 0), 0);
  const totalCommission = history.reduce((sum, tx) => sum + Number(tx?.commission || 0), 0);

  const columns = [
    { key: "txnId", label: "Txn ID" },
    { key: "txnDate", label: "Date", render: (v) => getDisplayDate(v) },
    {
      key: "narration",
      label: "Narration",
      render: (v) => <span className="text-indigo-700 font-medium">{v || "—"}</span>,
    },
    {
      key: "commission",
      label: "Comm",
      render: (v) => <span className="font-bold text-green-800">₹{Number(v || 0)?.toFixed(2)}</span>,
    },
    {
      key: "tds",
      label: "TDS",
      render: (v) => <span className="font-semibold text-red-800">₹{Number(v || 0)?.toFixed(2)}</span>,
    },
    {
      key: "txnAmount",
      label: "Net Amount",
      render: (v, row) => {
        const value = Number(v || 0);
        if (!value) return <span className="text-gray-400">—</span>;
        if (row.txnType === "CREDIT" || row.txnType === "Approved" || row.txnType === "REFUND")
          return <span className="font-semibold text-green-700">₹{value?.toFixed(2)}</span>;
        if (row.txnType === "DEBIT")
          return <span className="font-semibold text-red-600">₹{value?.toFixed(2)}</span>;
        return <span className="text-gray-400">—</span>;
      },
    },
    {
      key: "balance",
      label: "Balance",
      render: (v) => <span className="font-semibold text-blue-900">₹{Number(v || 0)?.toFixed(2)}</span>,
    },
  ];

  /* ================= UI ================= */
  return (
    <div className="min-h-screen sm:p-6 bg-[#EEF1F5]">
      {/* HEADER */}
      <div className="mb-8 p-4 sm:p-0">
        <h1 className="text-3xl font-bold text-[#0A2A4F]">Commission Section</h1>
        <p className="text-gray-600 text-sm mt-1">Manage commission reports and transfers</p>
      </div>

      {/* TABS */}
      <div className="flex mx-4 sm:mx-0 mb-6 rounded-xl overflow-hidden shadow">
        <button
          onClick={() => setActiveTab("COMMISSION")}
          className={`flex-1 py-3 font-semibold transition-colors ${
            activeTab === "COMMISSION" ? "bg-[#0A2A4F] text-white" : "bg-white text-gray-600 hover:bg-gray-50"
          }`}
        >
          Report
        </button>
        <button
          onClick={() => setActiveTab("TRANSFER")}
          className={`flex-1 py-3 font-semibold transition-colors ${
            activeTab === "TRANSFER" ? "bg-amber-600 text-white" : "bg-white text-gray-600 hover:bg-gray-50"
          }`}
        >
          Transfer
        </button>
      </div>

      <div className="mx-4 sm:mx-0 bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
        {activeTab === "COMMISSION" && (
          <>
            {/* FILTER BAR */}
            <div className="flex flex-wrap items-center gap-4 mb-6 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="h-10 px-3 border rounded-lg bg-white outline-none focus:ring-2 focus:ring-[#0A2A4F]"
              />
              <input
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
                className="h-10 px-3 border rounded-lg bg-white outline-none focus:ring-2 focus:ring-[#0A2A4F]"
              />

              <button
                onClick={() => fetchCommissionLedger(0)}
                disabled={loading}
                className="bg-[#0A2A4F] hover:bg-[#08203f] text-white px-6 py-2 rounded-lg font-semibold shadow transition-colors disabled:opacity-70"
              >
                {loading ? "Searching..." : "Search"}
              </button>

              {/* EXPORT BUTTON - Only visible after search and if there is data */}
              {isSearched && totalElements > 0 && (
                <button
                  onClick={downloadExcel}
                  disabled={loading || isExporting}
                  className={`h-10 px-6 rounded-lg text-white font-semibold shadow transition-colors flex items-center justify-center gap-2
                    ${isExporting ? "bg-green-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
                >
                  {isExporting ? (
                    <>
                      <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                      Preparing...
                    </>
                  ) : (
                    "Download Excel"
                  )}
                </button>
              )}
            </div>

            {/* TABLE */}
            <DynamicTable
              columns={columns}
              data={history}
              isLoading={loading}
              emptyText="No commission records found"
              rowClassName={(row) => {
                if (row.txnType === "DEBIT" || row.txnType === "REVERSED") return "bg-red-100";
                if (row.txnType === "REFUND") return "bg-yellow-100";
                if (row.txnType === "CREDIT" || row.txnType === "APPROVED") return "bg-green-100";
                if (row.txnType === "REJECTED") return "bg-red-200 border-l-4 border-red-600";
                return "";
              }}
              footerTotals={{
                totalNetAmount,
                totalTds,
                totalCommission,
              }}
            />

            {/* LOAD MORE */}
            {page + 1 < totalPages && (
              <div className="flex justify-center mt-6">
                <button
                  onClick={handleLoadMore}
                  disabled={loading}
                  className="px-8 py-3 bg-[#0A2A4F] text-white font-semibold rounded-xl hover:bg-[#08203f] transition-colors disabled:opacity-70"
                >
                  {loading ? "Loading..." : "Load Next Records"}
                </button>
              </div>
            )}
          </>
        )}

        {activeTab === "TRANSFER" && (
          <div className="max-w-md mx-auto p-6 bg-gray-50 rounded-xl border border-gray-200 mt-4">
            <div className="mb-6 pb-4 border-b border-gray-200">
              <p className="text-gray-500 text-sm">Available Commission Balance</p>
              <p className="text-3xl font-bold text-green-700">₹{commissionBalance}</p>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-semibold text-gray-700 mb-2">Transfer Amount (₹)</label>
              <input
                type="number"
                value={transferCommissionAmount}
                onChange={(e) => setTransferCommissionAmount(e.target.value)}
                className="w-full h-12 px-4 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-amber-500 font-semibold"
                placeholder="Enter amount to transfer"
              />
            </div>

            <button
              onClick={handleCommissionToMainTransfer}
              disabled={isLoadingCommission || !transferCommissionAmount}
              className="w-full h-12 bg-amber-600 hover:bg-amber-700 text-white font-bold rounded-lg transition-colors disabled:opacity-50"
            >
              {isLoadingCommission ? "Processing Transfer..." : "Transfer to Main Wallet"}
            </button>

            {commissionMessage && (
              <div className={`mt-4 p-3 rounded-lg text-sm font-semibold text-center ${
                commissionMessage.includes("success") ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
              }`}>
                {commissionMessage}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CommissionRetailer;